export default {
    HomeContainerGrid1: {"minHeight": "200px", "backgroundColor": "#706CD2", 'paddingLeft': '15px', 'paddingRight': '15px'},
    HomeContainerGrid2: {'textAlign': 'center', 'padding': '5px'},
    HomeContainerGrid3: {'textAlign': 'center', 'marginTop': '25px', 'padding': '5px'},
    HomeContainerGrid4: {'textAlign': 'center', 'marginTop': '25px', 'padding': '5px'},
    HomeContainerGrid5: {"marginTop": "25px", "minHeight": "150px", "oldMinHeight": "200px", "backgroundColor": "#706CD2", "textAlign": "center"},
    HomeContainerGrid6: {'minHeight': '200px', 'textAlign': 'center', 'marginBottom': '20px'},
    
    firstSectionText: {color: "#9E9E9E"},
    personalLoanBtn: {"width": "250px", "backgroundColor": "#FFF", "color": "#4FC3F7", "letterSpacing": ".3px"},
    autoLoanBtn: {"width": "250px", "marginTop": "10px", "backgroundColor": "#FFF", "color": "#4FC3F7", "letterSpacing": ".3px"},
}


// WEBPACK FOOTER //
// ./src/client/components/HomePage-Component/HomePageComponentStyle.js